import { useMutation } from '@tanstack/react-query';

import { LogoutDocument } from '../../../services/mutations/logoutDocument';
import { CacheKeys, graphQLClient } from '../../models/utils/constants';

const useLogoutCurrentUser = () => {
  const { mutateAsync } = useMutation({
    mutationKey: [CacheKeys.currentUser],
    mutationFn: async () => graphQLClient.request(LogoutDocument),
  });

  return {
    logout: mutateAsync,
  };
};

export default useLogoutCurrentUser;
